<template>
    <div>
        <b-row
            class="cursor-pointer"
            @click="show = !show"
        >
            <b-col cols="1">
                <span>
                    <b-img :src="`/img/languages/${current}.svg`" />
                </span>
            </b-col>
            <b-col
                class="px-2"
                cols="1"
            >
                <span class="current-language">{{ current }}</span>
            </b-col>
            <b-col class="pr-0">
                <span>
                    <font-awesome-icon
                        class="h-100"
                        size="xs"
                        :icon="`chevron-${show ? 'up' : 'down'}`"
                    />
                </span>
            </b-col>
        </b-row>
        <div
            v-show="show"
            class="position-absolute bg-white p-3 mt-3 shadow-sm rounded block-language"
        >
            <b-form-group
                v-slot="{ ariaDescribedby }"
                class="mb-0"
                :label="$t('main.header.language')"
            >
                <b-form-radio
                    v-for="language in languages"
                    :key="language.code"
                    v-model="current"
                    class="py-2 cursor-pointer"
                    name="code"
                    :aria-describedby="ariaDescribedby"
                    :value="language.code"
                    @change="setLocale"
                >
                    <div>
                        {{ language.name }} (<span class="text-uppercase">{{ language.code }}</span>)
                    </div>
                </b-form-radio>
            </b-form-group>
        </div>
    </div>
</template>

<script>
import { catalog } from '@/mixins/catalog';

export default {
    name: 'CheckLanguage',

    mixins: [catalog],

    data() {
        return {
            current: this.$i18n.locale,
            languages: [],
            show: false,
        };
    },

    methods: {
        setLocale: function() {
            if (this.current === this.$i18n.locale) {
                return;
            }

            localStorage.setItem('locale', this.current);
            this.$i18n.locale = this.current;
            document.title = this.$tc(`main.header.${this.$route.meta.title}`, 1) + ' | CRM';
            this.clearCatalog();
            this.show = false;
        },
    },

    async mounted() {
        const languages = await this.getCatalog('languages');
        this.languages = languages.filter(language => !['kk', 'lv'].includes(language.code));
    },
};
</script>

<style lang="scss" scoped>
span {
    line-height: 1.5em;
}
.block-language {
    z-index: 100;
}
.current-language {
    text-transform: uppercase;
    font-size: 11px;
}
</style>